// Overwritten by scripts/stamp-build-id.mjs at deploy time (full deploy
// tag, e.g. "v0.2.0-rc2"); 'dev' in local/dev builds. The tag — not the
// package.json version — identifies a build because staging deploys rc
// tags that share the same package version.
export const BUILD_ID = 'v0.1.30-rc2';
